import { withInstall } from '@jdesign-vue/utils'
import Cascader from './src/cascader.vue'

export const JdCascader = withInstall(Cascader)
export default JdCascader

export * from './src/cascader'
export * from './src/instances'
